/*
 * Copyright (c) Domotz Ltd. All rights reserved.
 */

import React, {Component} from 'react';
import './ChoroplethMap.css';
import Datamap from 'datamaps/dist/datamaps.world';
import d3 from 'd3';
import WorldJson from './world.json';

class ChoroplethMap extends Component {

    constructor(props) {
        super(props);
        this.resize = this.resize.bind(this);
        window.addEventListener('resize', this.resize);
        this.selector = React.createRef();
    }

    resize() {
        if (this.map) {
            this.map.resize();
        }
    }

    componentDidMount() {
        // Datamaps expect data in format:
        // { "USA": { "fillColor": "#42a844", numberOfWhatever: 75},
        //   "FRA": { "fillColor": "#8dc386", numberOfWhatever: 43 } }
        let dataset = {};

        // We need to colorize every country based on "numberOfWhatever"
        // colors should be uniq for every value.
        // For this purpose we create palette(using min/max this.props.data-value)
        let onlyValues = this.props.data.map(function (obj) {
            return obj[1];
        });
        let minValue = Math.min.apply(null, onlyValues),
            maxValue = Math.max.apply(null, onlyValues);

        // create color palette function
        // color can be whatever you wish
        let paletteScale;

        if (this.props.scaleLinear) {
            paletteScale = d3.scale.linear()
                        .domain([minValue, maxValue])
                        .range(this.props.colorRange); // blue color
        } else {
            paletteScale = d3.scale.log()
                .domain([minValue, maxValue])
                .range(this.props.colorRange); // blue color
        }

        // fill dataset in appropriate format
        this.props.data.forEach(function (item) { //
            // item example value ["USA", 70]
            let iso = item[0], value = item[1];
            dataset[iso] = {numberOfThings: value, fillColor: paletteScale(value), label: item[2]};
        });

        const rect = this.selector.current.getBoundingClientRect();
        console.log(rect);
        let scale = 100;

        // Match height with media queries in .css
        if (rect.height <= 240) {
            scale = 60;
        } else if (rect.height <= 300) {
            scale = 100;
        } else if (rect.height <= 340) {
            scale = 120;
        } else if (rect.height <= 400) {
            scale = 150;
        }

        let map = new Datamap({
            element: document.getElementById('choropleth_map'),
            scope: 'world',
            responsive: true,
            geographyConfig: {
                popupOnHover: true,
                highlightOnHover: true,
                borderColor: '#444',
                highlightBorderWidth: 1,
                borderWidth: 0.5,
                dataJson: WorldJson,
                popupTemplate: function (geo, data) {
                    // don't show tooltip if country don't present in dataset
                    if (!data) {
                        return;
                    }
                    // tooltip content
                    return ['<div class="hoverinfo">',
                        '<strong>', geo.properties.name, '</strong>',
                        '<br>', data.label,
                        '</div>'].join('');
                },
            },
            fills: {
                HIGH: '#afafaf',
                LOW: '#123456',
                MEDIUM: 'blue',
                UNKNOWN: 'rgb(0,0,0)',
                defaultFill: '#eee'
            },
            data: dataset,
            done: function (datamap) {
                datamap.svg.selectAll('.datamaps-subunit').on('click', function (geography) {
                    // TODO: do something on click
                    // alert(geography.properties.name);
                });
            },
            setProjection: function (element) {
                let projection = d3.geo.mercator()
                // .center([-106.3468, 68.1304]) // always in [East Latitude, North Longitude]
                    .scale(scale)
                    .translate([element.offsetWidth / 2, (element.offsetHeight/5)+element.offsetHeight / 2]);

                let path = d3.geo.path().projection(projection);
                return {path: path, projection: projection};
            }
        });

        this.map = map;
    }

    UNSAFE_componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
    }

    render() {
        return (
            <div id="choropleth_map" ref={this.selector} className="choroplet-map mb-4" />
        );
    }
}

export default ChoroplethMap;